import { Button, Flex, NumberInput, TextInput } from "@mantine/core";
import { FormColumnHalf } from "../components/common/Form/FormRow";
import Container from "../components/common/Container";
import PageHeader from "../components/common/PageHeader";
import { useForm } from "@mantine/form";
import styled from "styled-components";
import { validateRequired } from "../utils/validations";
import { createContract } from "../api/contractApi";
import { creationNotification, errorNotification } from "../utils/useNotification";
import { unwrap } from "../utils/apiResult";
import CustomDatePicker from "../components/common/Inputs/CustomDatePicker";
import { useAuth } from "../context/AuthContext";
import PlusIcon from "../components/common/Icons/PlusIcon";
import { useRef } from "react";

const NewContract = () => {
  const { refetchContractSelectData } = useAuth();
  const formRef = useRef<HTMLFormElement>(null);

  const form = useForm<any>({
    initialValues: {
      name: "",
      monthlyHours: "",
      startDate: undefined,
      endDate: undefined,
    },
    validate: {
      name: validateRequired,
      monthlyHours: validateRequired,
    },
  });

  const handleSubmit = async (values: object) => {
    try {
      const result = unwrap(await createContract({ ...values }));

      if (result.ok) {
        creationNotification("Kontrat", true);
        refetchContractSelectData();
        form.reset();
        return;
      }

      errorNotification({ message: result.message ?? undefined });
    } catch (error) {
      console.error("Error:", error);
      errorNotification();
    }
  };

  return (
    <Container>
      <PageHeader
        pageTitle="Yeni Kontrat Kaydı"
        isButtoned
        buttonText="Oluştur"
        buttonIcon={<PlusIcon />}
        buttonOnClick={() => formRef.current?.requestSubmit()}
      />
      <div style={{ display: "flex", flexDirection: "column", gap: "40px" }}>
        <form
          ref={formRef}
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "24px",
          }}
          onSubmit={form.onSubmit(handleSubmit)}
        >
          <FormColumnHalf>
            <TextInput
              label="Kontrat İsmi"
              placeholder="Kontrat İsmi Giriniz."
              maxLength={40}
              size="md"
              {...form.getInputProps("name")}
            />

            <NumberInput
              label="Aylık Çalışma Saati"
              placeholder="Örn: 10"
              hideControls
              size="md"
              {...form.getInputProps("monthlyHours")}
            />
            <CustomDatePicker
              label="Kontrat Başlangıç Tarihi"
              placeholder="Tarih Seçiniz."
              w="100%"
              size="md"
              {...form.getInputProps("startDate")}
            />
            <CustomDatePicker
              label="Kontrat Bitiş Tarihi"
              placeholder="Tarih Seçiniz."
              w="100%"
              size="md"
              {...form.getInputProps("endDate")}
            />
          </FormColumnHalf>
        </form>
      </div>
    </Container>
  );
};

export default NewContract;
